import { PathAPI } from '../../../api/datamanager/PathAPI';

export class PathsDraftCommand {
    getByLine(edition, lineId, providerId, successCallback, errorCallback) {
        const apiResult = PathAPI.listByLineDraft(edition.draftNetwork, lineId, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    getIntervals(edition, pathId, successCallback, errorCallback) {
        const apiResult = PathAPI.getIntervalsDraft(edition.draftNetwork, pathId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    getNotes(edition, pathId, successCallback, errorCallback) {
        const apiResult = PathAPI.getNotesDraft(edition.draftNetwork, pathId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    save(edition, path, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        const dataToSend = Object.assign({}, path);
        if (undefined !== path.line) {
            dataToSend.networkEdition = path.line.networkEdition;
            dataToSend.lineId = path.line.id;
            dataToSend.line = undefined;
        }

        if (undefined === dataToSend.id || 0 === dataToSend.id) {
            apiResult = PathAPI.createDraft(edition.draftNetwork, dataToSend);
            successMessage = "[Rascunho] Percurso criado com sucesso";
        }
        else {
            apiResult = PathAPI.updateDraft(edition.draftNetwork, dataToSend.id, dataToSend);
            successMessage = "[Rascunho] Percurso editado com sucesso";
        }
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    copy(edition, path, successCallback, errorCallback) {
        const apiResult = PathAPI.copyDraft(edition.draftNetwork, path);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    saveIntervals(edition, pathId, intervals, successCallback, errorCallback) {
        const apiResult = PathAPI.saveIntervalsDraft(edition.draftNetwork, pathId, intervals);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "[Rascunho] Periodos de Funcionamento guardados com sucesso",
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    saveNotes(edition, pathId, notes, successCallback, errorCallback) {
        const apiResult = PathAPI.saveNotesDraft(edition.draftNetwork, pathId, notes);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "[Rascunho] Notas guardadas com sucesso",
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(edition, pathId, successCallback, errorCallback) {
        const apiResult = PathAPI.delete(edition.draftNetwork, pathId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "[Rascunho] Percurso eliminado com sucesso",
                    data: undefined
                };

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}
